import React, { useState } from 'react';

const StateTags = () => {
  const [activeTag, setActiveTag] = useState(null);
  
  const states = [
    { name: "Delhi", icon: "fas fa-landmark", className: "delhi" },
    { name: "Maharashtra", icon: "fas fa-map-marker-alt", className: "maha" },
    { name: "West Bengal", icon: "fas fa-archway", className: "wb" },
    { name: "Karnataka", icon: "fas fa-city", className: "kar" },
    { name: "Tamil Nadu", icon: "fas fa-place-of-worship", className: "tn" },
    { name: "Uttar Pradesh", icon: "fas fa-mountain", className: "up" },
    { name: "Kerala", icon: "fas fa-tree", className: "ker" }
  ];

  const handleTagClick = (stateName) => {
    setActiveTag(stateName);
    console.log('Filtering by state:', stateName);
  };

  return (
    <div className="state-tags-container">
      {states.map((state, index) => (
        <div 
          key={index}
          className={`state-tag ${state.className} ${activeTag === state.name ? 'active' : ''}`}
          onClick={() => handleTagClick(state.name)}
        >
          <i className={state.icon}></i> {state.name}
        </div>
      ))}
    </div>
  );
};

export default StateTags;